import { DropdownMenuItem } from '@/components/ui/dropdown-menu';
import FilterMenu from '@/components/ui/filter-menu';
import { Skeleton } from '@/components/ui/skeleton';
import { useGetCategoriesQuery } from './category.api.slice';
import { ICategoryType } from './category.d';
import useSearchParamActions from '@/customHooks/useSearchParamActions';

function CategoryFilter({ submenu }: { submenu?: boolean }) {
  const { data: categories, isLoading } = useGetCategoriesQuery({
    type: ICategoryType.POST,
  });
  const { removeSearchParam, appendSearchParam } = useSearchParamActions();

  return (
    <FilterMenu
      label="Category"
      submenu={submenu}
      className="max-h-[400px] overflow-y-auto"
    >
      {isLoading ? (
        // ponytail: 6 fixed skeleton rows approximate the list; measure real category count if the residual jump ever bothers anyone
        <div className="w-40 space-y-1 p-1">
          {Array.from({ length: 6 }).map((_, i) => (
            <Skeleton key={`cat-skeleton-${i}`} className="h-8 w-full" />
          ))}
        </div>
      ) : (
        <DropdownMenuItem onClick={() => removeSearchParam('category')}>
          All
        </DropdownMenuItem>
      )}
      {categories?.map((category) => (
        <DropdownMenuItem
          key={category._id}
          onClick={() => appendSearchParam('category', category.name)}
        >
          {category.name}
        </DropdownMenuItem>
      ))}
    </FilterMenu>
  );
}

export default CategoryFilter;
